module.exports = __webpack_public_path__ + "img/icon-recibo-carousel.3be09d3f.svg";